import { LagoonContext } from './LagoonContext';

export const LagoonProvider = LagoonContext.Provider;
